import React from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { Footer } from "@mantine/core";
import CasinoCard from "../../../components/CasinoCard";
import { casinoTabs } from "../../../../lib/data";
import { useNavigate } from "react-router-dom";
import BackIcon from "../../../../assets/images/back-icon.png";

const Spribe = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>
      <main className="main mt-4 spribe-page">
        <div className=" container">
          <div className="headTitle mt-3">
            <div className="back-btn">
              <a href="javascript:void(0)" onClick={() => navigate(-1)}>
                <img src={BackIcon} alt="back" width={28} />
              </a>
            </div>

            <div className="title">
              <h3>Spribe</h3>
            </div>
          </div>

          <ul className="">
            {Array.isArray(Object.values(casinoTabs?.spribe.slide1)) &&
              Object.values(casinoTabs?.spribe.slide1)
              
                .map((game, idx) => (
                  <>
                    {console.log("game", game)}
                    <CasinoCard key={"casinogame" + idx} data={game} />
                  </>
                ))}
          </ul>
        </div>
      </main>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Spribe;
